const styles = (theme) => ({
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    maxWidth: '510px',
    backgroundColor: theme.color.white,
    borderRadius: 10,
    padding: theme.spacing(7, 3, 5),
  },
  closeIcon: {
    fontSize: 10,
  },
  closeIconButton: {
    position: 'absolute',
    top: 3,
    left: 3,
  },
  rightCloseIconButton: {
    position: 'absolute',
    top: 3,
    right: 3,
  },
  closeIconBig: {
    fontSize: 'medium',
  },
});

export default styles;
